// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from "./axios";
import { showSuccess, showError } from "../actions/globalActions";
import sanitizeModelPayload from '@staty/shared/utils/sanitizeModelPayload';

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const useRegistrationStore = create(immer((set) => ({
  registrations: [],

  // Methods to manipulate the state
  setRegistrations: (registrations) => {
    set((state) => {
      state.registrations = registrations;
    });
  },

  // Asynchronous actions
  getAllRegistrations: async (leagueName) => {
    try {
      const { data } = await axios.get(`${baseUrl}/registrations/organizationName/${leagueName}/all?include=contests,tournament.config.paymentProduct,contest.config.paymentProduct,tournament,contest,league`);
      set((state) => {
        state.registrations = data.result;
      });
    } catch (error) {
      console.error("Error in getRegistration:", error);
    }
  },

  getRegistrationById: async (registrationId, cb) => {
    try {
      const { data } = await axios.get(`${baseUrl}/registrations/${registrationId}?include=contests,tournament.config.paymentProduct,contest.config.paymentProduct`);
      console.log("getRegistrationById: ", data.result);
      cb && cb(data.result);
      set((state) => {
        const index = _.findIndex(state.registrations, { _id: registrationId });
        if (index >= 0) {
          state.registrations[index] = data.result;
        } else {
          state.registrations.push(data.result);
        }
      });
    } catch (error) {
      console.error("Error in getRegistration:", error);
    }
  },

  getRegistrationByTournamentId: async (tournamentId, cb) => {
    try {
      const { data } = await axios.get(`${baseUrl}/registrations/tournament/${tournamentId}?include=contests,tournament`);
      cb && cb(data.result);
      set((state) => {
        state.registrations.push(data.result);
      });
    } catch (error) {
      console.error("Error in getRegistrationByTournamentId:", error);
    }
  },

  getRegistrationByLeagueId: async (leagueId, cb) => {
    try {
      const { data } = await axios.get(`${baseUrl}/registrations/league/${leagueId}?include=contests,contest`);
      cb && cb(data.result);
      set((state) => {
        state.registrations.push(data.result);
      });
    } catch (error) {
      console.error("Error in getRegistrationByLeagueId:", error);
    }
  },

  updateRegistration: (getToken) => {
    return async (registration = {}, cb) => {
      try {
        const token = await getToken();
        const payload = sanitizeModelPayload({ model: 'registration' }, registration);
        const { data } = await axios.put(`${baseUrl}/registrations/d/${registration._id}`, payload, createAuthHeader(token));
        showSuccess("Success", "Successfully Updated");
        set((state) => {
          const index = state.registrations.findIndex(rf => rf._id === registration._id);
          if (index !== -1) {
            state.registrations[index] = data.result;
          }
        });
        cb && cb(data.result);
      } catch (error) {
        showError("Error", "Update Error");
        console.error("Error in updateRegistration:", error);
      }
    }
  },

  deleteRegistration: (getToken) => {
    return async (registrationId, cb) => {
      try {
        const token = await getToken();
        const { data } = await axios.delete(`${baseUrl}/registrations/d/${registrationId}`, createAuthHeader(token));
        showSuccess("Success", "Successfully Deleted");
        set((state) => {
          const index = state.registrations.findIndex(rf => rf._id === registrationId);
          if (index !== -1) {
            state.registrations.splice(index, 1);
          }
        });
        cb && cb(data.result);
      } catch (error) {
        showError("Error", "Delete Error");
        console.error("Error in deleteRegistration:", error);
      }
    }
  },

  updateRegistrationSettings: (getToken) => {
    return async (registration = {}, cb) => {
      try {
        const token = await getToken();
        const payload = sanitizeModelPayload({ model: 'registration' }, registration);
        const { data } = await axios.put(`${baseUrl}/registrations/d/${registration._id}/settings`, payload, createAuthHeader(token));
        showSuccess("Success", "Successfully Updated");
        set((state) => {
          const index = state.registrations.findIndex(rf => rf._id === registration._id);
          if (index !== -1) {
            state.registrations[index] = data.result;
          }
        });
        cb && cb(data.result);
      } catch (error) {
        showError("Error", "Update Error");
        console.error("Error in updateRegistrationSettings:", error);
      }
    }
  },

  addRegistration: (getToken) => {
    return async (registration = {}, cb) => {
      try {
        const token = await getToken();
        const { data } = await axios.post(`${baseUrl}/registrations`, registration, createAuthHeader(token));
        showSuccess("Success", "Successfully Added");
        set((state) => {
          state.registrations.push(data.result);
        });
        cb && cb(data.result);
      } catch (error) {
        showError("Error", "Add Error");
        console.error("Error in addRegistration:", error);
      }
    }
  },
})));

export default useRegistrationStore;
